<script>
    import { fly, fade } from 'svelte/transition';
    import { onMount } from 'svelte';
    let banner = true;
    let show;

    onMount(() => {
        setTimeout(() => {
           window.localStorage.setItem("bannerbox", show);
        }, 1000);

        let localdata = window.localStorage.getItem("bannerbox");

        if (localdata) {
            banner = false;
        }

        setTimeout(() => {
           banner = false;
        }, 5000);
    })
</script>
{#if banner }
    <div id="testing" class="banner-box" in:fly="{{ y: -200, duration: 2000 }}">
        <h1>
            Free delivery
        </h1>
        <p class="text-center">Free shipping across Bengaluru, order now!</p>
    </div>
{/if}

<style>
    .banner-box {
        z-index: 9999;
        padding: 20px 24px;
        border: 5px solid var(--primary);
        border-radius: 34px;
        display: flex;
        align-items: center;
        margin: 0 auto;
        flex-flow: column;
        position: fixed;
        left: 50%;
        transform: translate(-50%);
        background-image: url("../../../images/pattern2.png");
        top: 33px;
        width: 30%;
    }

    h1 {
        font-size: 16px;
        text-align: center;
        width: 100%;
        font-weight: 600;
        font-family: var(--primary-font);
        border-bottom: 1px solid #fff;
        padding-bottom: 16px;
        margin-bottom: 20px;
    }

    p {
        font-family: var(--primary-font);
        margin-bottom: 0;
        font-size: 16px;
    }
</style>